// @flow
import * as Cookie from 'app/packages/cookie-utils';
import storage from 'app/common/lib/Storage';
import { type UnauthSeoExperiments } from 'app/common/lib/react/withUnauthSeoExperiments';
import {
  HybridTiers,
  SHOWN_LOGIN_MODAL_IN_OPEN_COOLDOWN,
  TIER1_COUNTRIES,
  TIER2_COUNTRIES,
} from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';

// TODO lang future work to refactor this to App level
export default function getHybridTier(
  country: ?string,
  isBot: ?boolean = false,
  httpReferrer: ?string = '',
  seoUnauthExperiments: ?UnauthSeoExperiments,
  pinCategory?: string,
) {
  if (isBot) {
    return HybridTiers.tier1;
  }

  // special logic for yahoo jp partnership
  // https://docs.google.com/document/d/1hFgHvC9vz4PABLYQr7qPXvfpERKkgdBg5QKI2vxwR2M/edit
  if (httpReferrer && httpReferrer.includes('yahoo.co.jp') && country === 'JP') {
    return HybridTiers.tier1;
  }

  if (!country) {
    return HybridTiers.tier1;
  }

  country = country || '';

  if (TIER1_COUNTRIES.has(country)) {
    return HybridTiers.tier1;
  } else if (TIER2_COUNTRIES.has(country)) {
    return HybridTiers.tier2;
  } else {
    return HybridTiers.tier3;
  }
}

export function setCookieHasSeenLoginModal() {
  Cookie.set(
    PCONST.LOCALSTORAGE_HAS_BEEN_SHOWN_LOGIN_MODAL_IN_OPEN,
    'true',
    SHOWN_LOGIN_MODAL_IN_OPEN_COOLDOWN,
  );
}

/*
 * Squash default modal triggering logic for users in the Unauth
 * modal budget system. Modals will be shown by UnauthPageWrapper
 */
export function setUserInModalBudgetSystem(setting: boolean) {
  storage.sessionStorage.setItem(PCONST.SESSIONSTORAGE_USER_IN_MODAL_BUDGET, !!setting);
}

export function userInModalBudgetSystem() {
  return storage.sessionStorage.getItem(PCONST.SESSIONSTORAGE_USER_IN_MODAL_BUDGET) || false;
}

export function modalBudgetForUser(value?: number) {
  if (value !== undefined) {
    storage.sessionStorage.setItem(PCONST.SESSIONSTORAGE_MODAL_BUDGET_FOR_USER, value);
  }
  return storage.sessionStorage.getItem(PCONST.SESSIONSTORAGE_MODAL_BUDGET_FOR_USER) || 0;
}

/*
 * Allow power users the option to browse and disable
 * all 'automatic' modals
 */
export function setUserOpenUnauth(setting: boolean) {
  storage.localStorage.setItem(PCONST.LOCALSTORAGE_USER_OPT_IN_OPEN_UNAUTH, !!setting);
}

export function inUserOpenUnauth() {
  return storage.localStorage.getItem(PCONST.LOCALSTORAGE_USER_OPT_IN_OPEN_UNAUTH) || false;
}

export function inOpenModalExperience(budgetSystem: boolean = false) {
  return inUserOpenUnauth() || (!budgetSystem && userInModalBudgetSystem());
}
